/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState, useMemo } from 'react'
import { AppContext } from 'stores/AppStore'
import { useTranslation } from 'react-i18next'
import { UserContext } from 'stores/UserStore'
import { VallourecServicesDataContext } from 'stores/VallourecServicesDataStore'
import { LoadingOverlay, FlexView, Icon } from 'components/common'
import _ from 'lodash'
import FilteredTable from 'components/common/FilteredTable'
import moment from 'moment'
import { useHistory } from 'react-router-dom'

const VallourecServicesDataPage = () => {
    const history = useHistory()
    const DEFAULT_URL = "vallourec-services-data"
    const { t } = useTranslation()
    const { registryLog } = useContext(UserContext)
    const { setPageSubtitle } = useContext(AppContext)
    const {
        getLists,
        filteredVallourecServicesData: { listas },
        setSpecificList,
        setTotalPices
    } = useContext(VallourecServicesDataContext)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        setPageSubtitle(t('vallourecServicesData.pageTitle'))
    }, [setPageSubtitle, t])

    useEffect(() => {
        (async () => {
            setLoading(true)
            await getLists(1)
            setLoading(false)
        })()
        registryLog('Page In', DEFAULT_URL)
        registryLog(DEFAULT_URL, 'navigation', 'page_in')
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    const onRefreshClick = () => {
        (async () => {
            setLoading(true)
            await getLists(1)
            setLoading(false)
        })()
        registryLog('Refresh', DEFAULT_URL)
        registryLog(DEFAULT_URL, 'click', 'refresh')
    }

    const columns = useMemo(() => {
        const result = []
        result.push({
            Header: t('vallourecServicesData.list_name'),
            accessor: 'list_name',
            customHeaderProps: { style: { width: 'auto' } },
            customCellProps: { style: { width: '150px' } },
        })
        result.push({
            Header: t('vallourecServicesData.list_type'),
            accessor: 'list_type',
            customHeaderProps: { style: { width: 'auto' } },
            customCellProps: { style: { width: '150px', textTransform: 'capitalize' } },
        })
        result.push({
            Header: t('vallourecServicesData.items'),
            accessor: 'qtd',
            customHeaderProps: { style: { width: 'auto' } },
            customCellProps: { style: { width: '150px' } },
            disableFilters: true
        })
        result.push({
            Header: t('vallourecServicesData.dt_created'),
            accessor: 'dt_created',
            Cell: ({ cell: { value } }) => value ? moment.utc(value).format('DD/MM/YYYY') : '',
            customHeaderProps: { style: { width: 'auto' } },
            customCellProps: { style: { width: '150px' } },
        })
        result.push({
            Header: t('vallourecServicesData.options'),
            accessor: 'uuid',
            Cell: ({ cell: { row } }) => (
                <FlexView flexDirection="row" alignItems="center" justifyContent="center">
                    <Icon name="arrow-right" color="primary" margin="2px 15px" width="16px" height="16px" title={t('vallourecServicesData.showTags')} onClick={() => onShow(row.values)}></Icon>
                </FlexView>
            ),
            customHeaderProps: { style: { width: 'auto' } },
            customCellProps: { style: { width: '150px' } },
            disableFilters: true
        })
        return result
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [t]) 

    const onShow = (item) => {
        setSpecificList(item.uuid)
        setTotalPices(item.qtd)
        history.push('/vallourec-services-data/tags')
    }
    return <FlexView flex="1" position="relative" alignSelf="stretch">
        <FlexView margin="10px 20px 4px" flexDirection="row" justifyContent="space-between" alignSelf="stretch" alignItems="center">
            <FlexView flexDirection="row" alignItems="center" justifyContent="flex-start" alignSelf="stretch" margin="16px">
                <Icon name='report' width="30px" height="36px"></Icon>
                <FlexView fontSize="big" fontWeight="bold" color="gray" margin="0px 8px 0px 8px">{t('vallourecServicesData.pageSubtitle')}</FlexView>
            </FlexView>
            <FlexView flexDirection="row" margin="10px 20px 4px" alignItems="center" justifyContent="flex-end" flex="1">
                <Icon name="refresh" width="28px" height="28px" margin="0px 15px 0px" tooltip={t('Refresh')} onClick={onRefreshClick} />
            </FlexView>
        </FlexView>
        <FlexView margin="10px 20px 4px" flexDirection="column" alignSelf="stretch">
            <FilteredTable width="100%" data={listas} columns={columns} style={{ whiteSpace: 'nowrap', textAlign: 'center' }} />
        </FlexView>
        <LoadingOverlay visible={loading} />
    </FlexView>
}

export default VallourecServicesDataPage
